/* istanbul ignore file */
import React from 'react';
import { TRACKING } from 'common/constants/constants';
import investmentProfileCTA from 'images/investmentProfileMetricsCTA.svg';
import CtaPage from 'components/CtaPage';
import { TEXT_POSITION } from 'components/CtaPage/constants';

const SECTION_TYPES = {
  INVESTMENT_PROFILE: 'INVESTMENT_PROFILE',
  OVER_TIME: 'OVER_TIME',
  TABLE: 'TABLE'
};

const TEXTS = {
  [SECTION_TYPES.INVESTMENT_PROFILE]:
    'See your cumulative engineering investment by iteration' +
    ' on a per-team basis and use this visibility to optimize' +
    ' your strategy and work on what matters most.',
  [SECTION_TYPES.OVER_TIME]:
    'Investigate a team’s cumulative FTE effort iteration-by-iteration' +
    ' to see what they worked on and find opportunities to shift' +
    ' resources, reprioritize work, and focus on initiatives that drive value.',
  [SECTION_TYPES.TABLE]:
    'See your investment data in a bar chart visualization' +
    ' or table view–whichever you find most helpful.'
};

const InvestmentProfileCta = () => (
  <CtaPage
    textsMap={TEXTS}
    page={TRACKING.PAGES.METRICS}
    pageTab={TRACKING.PAGE_TABS.INVESTMENT_PROFILE_CTA}
    buttonLineProps={{
      textWidth: '70%',
      leftText: 'Unlock investment profile dashboard to see!'.toUpperCase(),
      buttonText: 'BOOK A DEMO NOW'
    }}
    backgroundImage={investmentProfileCTA}
    sections={[
      {
        sectionType: SECTION_TYPES.INVESTMENT_PROFILE,
        buttonPosition: {
          left: '43%',
          top: '7rem'
        },
        coverProps: {
          height: '15rem',
          width: '100%'
        },
        textPosition: {
          left: TEXT_POSITION,
          top: '6rem'
        },
        isTextLeft: true
      },
      {
        sectionType: SECTION_TYPES.OVER_TIME,
        buttonPosition: {
          right: '35%',
          top: '25rem'
        },
        coverProps: {
          height: '20rem',
          width: '100%',
          position: { right: 0, top: '15rem' }
        },
        textPosition: {
          right: TEXT_POSITION,
          top: '14rem'
        }
      },
      {
        sectionType: SECTION_TYPES.TABLE,
        buttonPosition: {
          left: '35%',
          top: '40rem'
        },
        coverProps: {
          height: '15rem',
          width: '100%',
          position: { right: 0, top: '35rem' }
        },
        textPosition: {
          left: TEXT_POSITION,
          bottom: '6rem'
        },
        isTextLeft: true
      }
    ]}
  />
);

export default InvestmentProfileCta;
